
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu } from "@headlessui/react";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 w-full bg-transparent z-50">
      <div className="max-w-screen-xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center">
          <img src="/images/logo1.png" alt="Logo" className="h-16 hidden md:block" />
        </div>

        {/* Mobil Menü Butonu */}
        <button className="md:hidden text-3xl text-black" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          {isMenuOpen ? "✖" : "☰"}
        </button>

        {/* Menü */}
        <nav
          className={`fixed top-16 left-1/2 -translate-x-1/2 w-[90%] max-w-[320px] bg-white/80 backdrop-blur-md shadow-xl rounded-xl p-4 md:bg-transparent md:shadow-none md:static md:flex md:space-x-6 text-[15px] font-medium ${isMenuOpen ? "block" : "hidden"
            } md:block`}
        >
          <Link to="/" className="block px-5 py-2 text-green-700 hover:text-green-500 font-semibold tracking-wide" onClick={handleLinkClick}>
            ANASAYFA
          </Link>
          <Link to="/kurumsal" className="block px-5 py-2 text-green-700 hover:text-green-500 font-semibold tracking-wide" onClick={handleLinkClick}>
            KURUMSAL
          </Link>

          {/* Hizmetler Dropdown */}
          <Menu as="div" className="relative">
            <Menu.Button className="block px-5 py-2 text-green-700 hover:text-green-500 font-semibold tracking-wide">HİZMETLER</Menu.Button>
            <Menu.Items className="absolute top-full left-0 mt-2 w-64 bg-green-500 shadow-lg rounded-lg p-2 z-50">
              {[
                { path: "/hali-yikama", label: "HALI YIKAMA" },
                { path: "/koltuk-yikama", label: "KOLTUK YIKAMA" },
                { path: "/yatak-yikama", label: "YATAK YIKAMA" },
                { path: "/stor-zebra-perde-yikama", label: "STOR-ZEBRA PERDE YIKAMA" },
                { path: "/yorgan-yikama", label: "YORGAN YIKAMA" },
                { path: "/yerinde-yikama", label: "YERİNDE YIKAMA" },
                { path: "/kuru-temizleme", label: "KURU TEMİZLEME" },
                { path: "/hali-tamir-overlok", label: "HALI TAMİR-OVERLOK" },
              ].map((service) => (
                <Menu.Item key={service.path}>
                  {({ active }) => (
                    <Link
                      to={service.path}
                      onClick={handleLinkClick}
                      className={`block px-5 py-2 text-white font-medium ${active ? "bg-green-600" : ""}`}
                    >
                      {service.label}
                    </Link>
                  )}
                </Menu.Item>
              ))}
            </Menu.Items>
          </Menu>

          {/* Hizmet Bölgeleri Dropdown */}
          {/* Hizmet Bölgeleri Dropdown */}
<Menu as="div" className="relative">
  <Menu.Button className="block px-5 py-2 text-green-700 hover:text-green-500 font-semibold tracking-wide">
    HİZMET BÖLGELERİ
  </Menu.Button>
  <Menu.Items className="absolute top-full left-0 mt-2 w-64 max-h-96 overflow-y-auto bg-gray-500 shadow-lg rounded-lg p-2 z-50">
    {[
      { path: "/kucukcekmece-hali-yikama", label: "Küçükçekmece" },
      { path: "/bahcelievler-hali-yikama", label: "Bahçelievler" },
      { path: "/gungoren-hali-yikama", label: "Güngören" },
      { path: "/bagcilar-hali-yikama", label: "Bağcılar" },
      { path: "/esenler-hali-yikama", label: "Esenler" },
      { path: "/bayrampasa-hali-yikama", label: "Bayrampaşa" },
      { path: "/besiktas-hali-yikama", label: "Besiktaş" },
      { path: "/sultangazi-hali-yikama", label: "Sultangazi" },
      { path: "/gaziosmanpasa-hali-yikama", label: "Gaziosmapaşa" },
      { path: "/kagithane-hali-yikama", label: "Kağıthane" },
      { path: "/sisli-hali-yikama", label: "Şişli" },
      { path: "/sariyer-hali-yikama", label: "Sarıyer" },
      { path: "/avcilar-hali-yikama", label: "Avcılar" },
      { path: "/arnavutkoy-hali-yikama", label: "Arnavutköy" },
      { path: "/basaksehir-hali-yikama", label: "Başakşehir" },
      { path: "/buyukcekmece-hali-yikama", label: "Büyükçekmece" },     
      { path: "/beylikduzu-hali-yikama", label: "Beylikdüzü" },
      { path: "/esenyurt-hali-yikama", label: "Esenyurt" },
      { path: "/eyupsultan-hali-yikama", label: "Eyüpsultan" },
      { path: "/fatih-hali-yikama", label: "Fatih" },
      { path: "/zeytinburnu-hali-yikama", label: "Zeytinburnu" },
      { path: "/bakirkoy-hali-yikama", label: "Bakırköy" },
      { path: "/beyoglu-hali-yikama", label: "Beyoğlu" },
      
    ].map((location) => (
      <Menu.Item key={location.path}>
        {({ active }) => (
          <Link
            to={location.path}
            onClick={handleLinkClick}
            className={`block px-5 py-2 text-white font-medium ${active ? "bg-gray-600" : ""}`}
          >
            {location.label}
          </Link>
        )}
      </Menu.Item>
    ))}
  </Menu.Items>
</Menu>


          <Link to="/blog" className="block px-5 py-2 text-green-700 hover:text-green-500 font-semibold tracking-wide" onClick={handleLinkClick}>
            BLOG
          </Link>
          <Link to="/galeri/koltuk-yikama" className="block px-5 py-2 text-green-700 hover:text-green-500 font-semibold tracking-wide" onClick={handleLinkClick}>
            FOTO GALERİ
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
